
function submitDisabled($submitButton, disabledBool) {
  $submitButton.prop('disabled', disabledBool);
}

$(document).ready(function() {

  if ($('form').length && !$('fieldset.reference-upload, fieldset.search-faqs, fieldset.find-faq-answer, fieldset.search-profiles, fieldset.service-type, fieldset.profile-picture').length) {

    $('form').each(function(index) {

      var $submitButton = $(this).find('[type=submit]');

      var validate =
        $(this).validate({
          errorClass: 'jqv-inline-error',
          errorElement: 'span',
          ignore: '.fade',
          errorPlacement: function(error, element) {
            error.insertBefore(element);
          }
      });

      if(validate.checkForm()) {
        submitDisabled($submitButton, false);
      } else {
        $('.form-control, .form-check-input').on('change', function() {
          checkValid($submitButton, $(this), validate);
        });
        $('textarea').on('keyup input propertychange', function() {
          checkValid($submitButton, $(this), validate);
        });
      }
    });

    function checkValid($submitButton, theForm, validate) {
      var isValid = validate.checkForm();
      console.log(isValid);
      if(isValid) {
        submitDisabled($submitButton, false);
      } else {
        submitDisabled($submitButton, true);
      }
    }
  }
});
